import Icon from "../Icon/Icon";
import { ActionIcon, Group, Title } from "@mantine/core";
import type { ReactNode } from "react";

export default function ModalHeader({
  title,
  onClose,
  leftSection
}: {
  title: string;
  onClose?: () => void;
  leftSection?: ReactNode;
}) {
  return (
    <Group justify="space-between" gap="xs" px="md">
      <Group gap="xs">
        {leftSection}
        <Title order={4}>{title}</Title>
      </Group>
      {typeof onClose === "function" && (
        <ActionIcon onClick={onClose}>
          <Icon name="xmark" size="1rem" />
        </ActionIcon>
      )}
    </Group>
  );
}
